module.exports = __webpack_public_path__ + "static/29-thumb-62a893ccb13cf3c3b36703b4aa94ff03.jpg";